module.exports = __webpack_public_path__ + "4a95f93c8b09ffab9251de33d7819b98.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_1.mp3
 ** module id = 166
 ** module chunks = 0
 **/